module.exports = ".thumb-fade{\r\n\tposition: absolute;\r\n\tbackground-color: #000;\r\n\twidth:100%;\r\n\tmax-height: 113px;\r\n\topacity:0;\r\n\t-webkit-transition: 1s opacity;\r\n\ttransition: 1s opacity;\r\n\tcolor:#fff;\r\n\ttext-align: center;\r\n\tline-height: 113px;\r\n}\r\n.thumb-fade:hover{\r\n\topacity: 0.7;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/imoveis/imoveis.component.css
// module id = ./src/app/imoveis/imoveis.component.css
// module chunks = main